





























import Vue from "vue";
import { ConfirmDialog } from "@/models/confirmDialog";
import VaButton from "@/components/atoms/VaButton.vue";
import VaCard from "@/components/molecules/VaCard.vue";

export default Vue.extend({
  components: {
    VaCard,
    VaButton,
  },
  computed: {
    dialog(): ConfirmDialog {
      return this.$store.getters["notifications/confirmDialog"];
    },
  },
  methods: {
    confirm() {
      this.dialog.callback();
      this.dismiss();
    },
    dismiss() {
      if (this.dialog.closeCallback) this.dialog.closeCallback();
      this.$store.commit("notifications/dismissConfirmDialog");
    },
  },
});
